/**
 * Organization-scoped feature flag keys used for UI gating.
 */
import { useMemo } from "react";
import { useOrganizationStore } from "../store/useOrganizationStore";

export const FLAG_TEST_PROCEDURES = "test-procedures-enabled";
export const FLAG_VIDEO_REALTIME_WORKFLOW = "video-realtime-workflow-enabled";
export const FLAG_RMA_ANALYSIS = "rma-analysis-enabled";
export const FLAG_TRACK_CHANGES = "track-changes-enabled";
export const FLAG_COMPARE_VERSIONS = "compare-versions-enabled";
export const FLAG_CAD_PIPELINE = "cad-pipeline-enabled";
export const FLAG_DRAWINGS_PIPELINE = "drawings-pipeline-enabled";
export const FLAG_VIDEO_PIPELINE = "video-pipeline-enabled";
export const FLAG_IMAGE_PIPELINE = "image-pipeline-enabled";

export function useFeatureFlagEnabled(flagKey: string): boolean {
  const organizations = useOrganizationStore((state) => state.organizations);
  const activeOrgId = useOrganizationStore((state) => state.activeOrgId);

  return useMemo(() => {
    const org = organizations.find((item) => item.orgId === activeOrgId);
    const features = org?.features ?? {};
    return features[flagKey] === true;
  }, [organizations, activeOrgId, flagKey]);
}
